import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";

export default function RequireAuth({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-[#08080D]" />;
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}
